import React from 'react';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import '@reach/dialog/styles.css';
import { animated, useSpring } from 'react-spring';
import { NavbarCategory } from 'Types';
import { useRouter } from 'next/router';
import { XIcon } from '@heroicons/react/outline';
import classnames from 'classnames';
import { getTranslation } from 'dictionary';
import { useUserContext } from 'context/UserContext';
import Link from 'next/link';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  categories: NavbarCategory[];
}

const OrderModal: React.FC<Props> = ({ isOpen, handleClose, categories }) => {
  const { language } = useUserContext();

  const AnimatedDialogOverlay = animated(DialogOverlay);
  const AnimatedDialogContent = animated(DialogContent);
  const router = useRouter();
  const { left } = useSpring({
    from: { left: '-100%' },
    left: isOpen ? '0' : '-100%',
  });
  const handleCategoryClick = (category: NavbarCategory) => {
    router.push(`#${category.id}`, undefined, { shallow: true });
    handleClose();
  };
  const [_, categoryDisplayed] = router.asPath.split('#');

  return (
    <>
      <AnimatedDialogOverlay
        isOpen={isOpen}
        onDismiss={handleClose}
        style={{ zIndex: 30 }}
      >
        <AnimatedDialogContent
          style={{
            height: '100%',
            padding: 0,
            paddingBottom: 10,
            margin: 0,
            position: 'absolute',
            top: 0,
            left: left,
            width: '100%',
            maxWidth: 400,
          }}
        >
          <nav className="max-h-screen bg-white px-2 py-4 min-h-full flex flex-col">
            <div className="flex h-7 items-center justify-between px-2">
              <h3 className="text-lg font-medium text-gray-900">
                {language === 'EN' ? 'CATEGORIES' : 'CATEGORIAS'}
              </h3>
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                onClick={handleClose}
              >
                <span className="sr-only">Close panel</span>
                <XIcon className="w-6 h-6 " onClick={handleClose} />
              </button>
            </div>
            <ul className="grow overflow-y-scroll py-4">
              {categories.map((category) => (
                <li key={category.id}>
                  <button
                    onClick={() => handleCategoryClick(category)}
                    className={classnames(
                      'hover:text-gray-900 truncate w-full mt-2 hover:bg-gray-100 group flex items-center px-2 py-2 text-sm  rounded-md ',
                      {
                        'bg-gray-100 text-gray-900 font-medium':
                          category.id === categoryDisplayed,
                      }
                    )}
                  >
                    {category.title}
                  </button>
                </li>
              ))}
            </ul>
            <div className="text-center text-gray-new font-light">
              {getTranslation('menu', 'CREATED_WITH', language)}
              <Link
                href="/"
                className="font-rochester text-logosmall px-1 logo font-medium"
              >
                Simple
              </Link>
            </div>
          </nav>
        </AnimatedDialogContent>
      </AnimatedDialogOverlay>
    </>
  );
};

export default OrderModal;
